<template>
    <div class="list">
        <p>{{title}}</p>
        <div class="dropdown" v-on-click-outside="hideDropDown">
            <input :id="'dd-edit-' + name" type="checkbox" v-model="showList">
            <label :for="'dd-edit-' + name" :class="{saved: savedFields.hasOwnProperty(name) && !changed}">
                <span :class="{ 'dd-darken' : typeCheck }">{{selectedItem[fieldName] || 'Не выбрано'}}</span>
                <span class="triangle"></span>
            </label>
            <ul>
                <li v-for="item in items" v-if="item.id !== selectedItem.id"
                    @click="onItem(item)">{{item[fieldName]}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
  import {mixin as onClickOutside} from 'vue-on-click-outside'
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapState} = createNamespacedHelpers('editPage')

  export default {
    mixins: [onClickOutside],
    props: ['fieldName', 'title', 'id', 'url', 'name'],
    data() {
      return {
        showList: false,
        items: [],
        changed: false,
        selectedItem: ''
      }
    },
    computed: {
      ...mapState([
        'item',
        'filterParams',
        'commonField',
        'commonFields',
        'savedFields'
      ])
    },
    methods: {
      ...mapMutations([
        'setItemField'
      ]),
      typeCheck() {
        if (this.fieldName === 'name'
          || this.fieldName === 'title')
          return true
      },
      hideDropDown() {
        this.showList = false
      },
      getItems() {
        this.$http.get(
          `${this.url}?search=parent_id:${this.id};is_active:1&searchJoin=and&orderBy=created_at&sortedBy=desc`
        ).then(response => {
          if (response.data.data) {
            this.items = response.data.data
            for (let i = 0; i < this.items.length; i++) {
              if (this.items[i].id === this.item[this.name]) {
                this.selectedItem = this.items[i]
              }
            }
          }
        }).catch(error => {
          this.$store.dispatch('notification/errorAxios', error.response.status, {root: true})
        })
      },
      onItem(item) {
        this.changed = true
        this.hideDropDown()
        this.setItemField({fieldName: this.name, value: item.id});
        this.selectedItem = item
      }
    },
    mounted() {
      this.getItems()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/edit-form/DropDown.vue